import cx from 'classnames';
import PropTypes from 'prop-types';

import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';

import { useStyles } from './useStyles';

export const CustomTag = ({ className, tag }) => {
  const styles = useStyles();

  if (!tag) {
    return null;
  }

  return (
    <CustomTypography
      className={cx(className, styles.root)}
      variant={TYPOGRAPHY_VARIANT.medium12}
    >
      {tag}
    </CustomTypography>
  );
};

CustomTag.propTypes = {
  className: PropTypes.string,
  tag: PropTypes.string.isRequired,
};

CustomTag.defaultProps = {
  className: null,
};
